import { apiStates } from '~constants/api';

import { get } from '~libs/genericAction';
import { createThunks } from '~libs/reduxUtils';

export const typePrefix = 'states';

const config = [
  {
    actionType: 'getAll',
    apiPath: apiStates,
    method: get,
    actionParams: { attributes: ['id', 'name'], limit: 0 },
  },
];

export const { getAll } = createThunks(typePrefix, config);
